<template>
<div class="chapter">
<div class="inner_page">
<p class="line" id="blueline1"><img alt="image" src="Images/blueline.jpg"/></p>
<p class="tx"><i>Wow!</i> you think to yourself. <i>This black man talking to me is so articulate!</i> You mean it as a compliment. </p>
<p class="ser"> </p>
<p class="tx">You can keep that to yourself. That black man is the judge in your DUI trial. Maybe let your lawyer do the talking.</p>
<p class="line" id="blueline2"><img alt="image" src="Images/blueline.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap6.vue?66ee86a5